import { HourglassIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import { formatDuration } from 'app/lib/workflows/format'
import type { WaitFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Pauses the run for a fixed duration before continuing. */
export function WaitNode({ data, selected }: NodeProps<WaitFlowNode>) {
  return (
    <NodeShell
      icon={HourglassIcon}
      accent="amber"
      kind="Wait"
      label={data.label}
      description={formatDuration(data.duration, data.unit)}
      selected={selected}
    />
  )
}
